<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.equivalencesCours"
      add-new-text="Ajouter un cours"
      :live="{ endpoint: 'sas-equivalence-cours', sasId: sas.id }"
      card-width="900"
      :icon="$getIcon('cours')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3 v-if="item.titre">{{ item.titre }}</h3>
        <p class="my-0" v-if="item.sigleOuNumero">{{ item.sigleOuNumero }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-text-field code="numero-cours" v-model="item.sigleOuNumero" :live="liveSasCours(6802, item)" optional></opq-text-field>
        <opq-text-field code="titre-cours" v-model="item.titre" :live="liveSasCours(6803, item)"></opq-text-field>
        <opq-catalogue code="credits-cours" v-model="item.creditsAttribues" :live="liveSasCours(6804, item)"></opq-catalogue>
        <opq-text-field
          :opq-if="estOui(item.creditsAttribues)"
          code="nombre-credits-cours"
          v-model="item.nombreDeCredits"
          :live="liveSasCours(6805, item)"
          isNumber
        ></opq-text-field>
        <opq-text-field
          :opq-if="estNon(item.creditsAttribues)"
          code="nombre-heures-cours"
          v-model="item.nombreDHeures"
          :live="liveSasCours(6806, item)"
          isNumber
        ></opq-text-field>
        <opq-relation
          code="selection-releve-note-cours"
          v-model="item.releveDeNote"
          :live="liveSasCours(6807, item)"
          :list="relevesDeNotes"
        ></opq-relation>
        <opq-file-multiple code="description-cours" :files="item.descriptionOuPlanDeCours" :live="liveSasCours(6809, item)"></opq-file-multiple>
        <opq-catalogue code="type-cours" v-model="item.typeCours" :live="liveSasCours(6810, item)" optional :filter="filtreTypeCours"></opq-catalogue>
        <opq-catalogue
          :opq-if="estTypeCoursDeBase(item.typeCours)"
          code="categorie-base-cours"
          v-model="item.categorieBase"
          :live="liveSasCours(6811, item)"
          optional
        ></opq-catalogue>
        <opq-catalogue
          :opq-if="estTypeCoursCompetence(item.typeCours)"
          code="categorie-competence-cours"
          v-model="item.categorieCompetence"
          :live="liveSasCours(6812, item)"
          optional
        ></opq-catalogue>
        <opq-alert
          v-show="codeRessourceDescCompCompetenceCours(item.categorieCompetence)"
          :code="codeRessourceDescCompCompetenceCours(item.categorieCompetence)"
        ></opq-alert>
        <opq-catalogue
          :opq-if="estCategorieCompetenceEvaluation(item.categorieCompetence)"
          code="type-evaluation-cours"
          v-model="item.typeEvaluation"
          :live="liveSasCours(6815, item)"
        ></opq-catalogue>
        <opq-catalogue
          :opq-if="estCategorieCompetenceIntervention(item.categorieCompetence)"
          code="type-intervention-cours"
          v-model="item.typeIntervention"
          :live="liveSasCours(6816, item)"
        ></opq-catalogue>
        <opq-memo code="pertinence-cours" v-model="item.pertinenceCours" :live="liveSasCours(6817, item)" optional></opq-memo>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  data() {
    return {
      codeRessourceByTypeCategorieCompetence: {
        RI: "desc-comp-relation",
        EV: "desc-comp-evaluation",
        IN: "desc-comp-intervention",
        RE: "desc-comp-recherche",
        ET: "desc-comp-ethique",
        CO: "desc-comp-consultation",
        SU: "desc-comp-supervision"
      }
    }
  },

  computed: {
    relevesDeNotes() {
      let releves = []
      this.sas.diplomes.forEach((diplome) => {
        diplome.relevesDeNotes
          .filter((r) => r.id && r.name && r.lien)
          .forEach((releve) => {
            releves.push(releve)
          })
      })
      return releves
    }
  },
  methods: {
    liveSasCours(cle, item) {
      return { endpoint: "sas-equivalence-cours", cle: cle, fileId: item.id }
    },
    estTypeCoursDeBase(typeCours) {
      return this.getCatalogueCodeById(6902, typeCours) == "BA"
    },
    estTypeCoursCompetence(typeCours) {
      return this.getCatalogueCodeById(6902, typeCours) == "CO"
    },
    estCategorieCompetenceEvaluation(categorie) {
      return this.getCatalogueCodeById(6913, categorie) == "EV"
    },
    estCategorieCompetenceIntervention(categorie) {
      return this.getCatalogueCodeById(6913, categorie) == "IN"
    },
    codeRessourceDescCompCompetenceCours(categorie) {
      return this.codeRessourceByTypeCategorieCompetence[this.getCatalogueCodeById(6913, categorie)]
    },
    filtreTypeCours(fd) {
      return fd.code == "BA" || fd.code == "CO"
    }
  }
}
</script>

<style>
</style>